import { withLoginUser } from 'src/api/user'
import { GuestPageWrapper, MemberPageWrapper } from 'src/components/PageWrapper'
import { ExhibitionPageLayout } from './ExhibitionPageLayout'

export const ExhibitionPage = withLoginUser(({ user, loggedIn }) => {
  return (
    <>
      {loggedIn ? (
        <MemberPageWrapper user={user} currentPath="オンライン展示会">
          <ExhibitionPageLayout />
        </MemberPageWrapper>
      ) : (
        <GuestPageWrapper>
          <ExhibitionPageLayout />
        </GuestPageWrapper>
      )}
    </>
  )
})
